import {collection, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";

export enum MetaTagType {
    DOCKET_SELECTOR = <any>"PRODUCT",
    PREPARATION = <any>"PREPARATION",
    PREPARED_MESSAGE = <any>"PREPARED MESSAGE",
    ORDER_READY_QUALIFIER = <any>"ORDER READY QUALIFIER"
}

export class MetaTagValueData extends EntityData<MetaTagValueData> {
    @field metaTagValueId: number;
    @field name: string;
}
export class MetaTagDefinitionData extends LocalisableEntityData<MetaTagDefinitionData> {
    public static readonly MATCH_UNTAGGED_ITEM: number = 0;

    @identifier metaTagDefinitionId: number;
    @field name: string;
    @field type: MetaTagType;
    @collection(MetaTagValueData) values: MetaTagValueData[];
}

export class MetaTagDefinitionReferenceData extends LocalisableEntityData<MetaTagDefinitionReferenceData> {
    @identifier metaTagDefinitionId: number;
    @field name: string;
    @field type: MetaTagType;
}
